<template>
    <div class="animated fadeIn">
        <b-row class="py-2 w-100">
            <h4 class="text-center w-100 text-primary">
                <i class="fa fa-user pr-2 "></i>Alta de Nuevo Socio
            </h4>
            <b-card class="w-75 mx-auto shadow-sm" v-if="headquarters">
                <b-container class="w-100 px-0">

                    <b-form @submit.prevent="store" class="w-100" enctype="multipart/form-data">
                        <div class="progress-group">
                            <div class="progress-group-header">
                                <i class="cui-user progress-group-icon"></i>
                                <div>Información Principal</div>
                                <div class="ml-auto font-weight-bold">Paso 1 de 4</div>
                            </div>
                            <div class="progress-group-bars">
                                <div class="progress progress-xs">
                                    <div
                                        aria-valuemax="100"
                                        aria-valuemin="0"
                                        aria-valuenow="25"
                                        class="progress-bar bg-warning"
                                        role="progressbar"
                                        style="width: 25%">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-row class="bg-light mx-0 px-4 py-4">
                            <b-col lg="8" md="10" offset-lg="2">
                                <!-- NIF !-->
                                <b-form-group
                                    :horizontal="true"
                                    class="w-100 text-right my-0"
                                    label="<strong>NIF *</strong>"
                                    label-cols="4"
                                    label-for="nif">
                                    <b-form-input
                                        :state="validateState('nif')"
                                        aria-describedby="check_nif"
                                        class="w-100"
                                        id="nif"
                                        name="nif"
                                        placeholder="NIF"
                                        type="text"
                                        v-model="entity.nif"
                                        v-validate="'required|nif'">
                                    </b-form-input>
                                </b-form-group>
                                <div class="text-danger text-right" id="check_nif">
                                    <small>{{ errors.first('nif') }}</small>
                                </div>
                                <!-- Nombre !-->
                                <b-form-group
                                    :horizontal="true"
                                    class="w-100 text-right mt-3 mb-0"
                                    label="<strong>Nombre *</strong>"
                                    label-cols="4"
                                    label-for="name">
                                    <b-form-input
                                        :state="validateState('name')"
                                        aria-describedby="check_name"
                                        class="w-100" id="name"
                                        name="name"
                                        placeholder="Nombre"
                                        type="text"
                                        v-model="entity.name"
                                        v-validate="'required|min:3'">
                                    </b-form-input>
                                </b-form-group>
                                <div class="text-danger text-right" id="check_name">
                                    <small>{{ errors.first('name') }}</small>
                                </div>
                                <!-- Apellidos !-->
                                <b-form-group
                                    :horizontal="true"
                                    class="w-100 text-right mt-3 mb-0"
                                    label="<strong>Apellidos *</strong>"
                                    label-cols="4"
                                    label-for="surname">
                                    <b-form-input
                                        :state="validateState('surname')"
                                        aria-describedby="check_surname"
                                        class="w-100"
                                        id="surname"
                                        name="surname"
                                        placeholder="Apellidos"
                                        type="text"
                                        v-model="entity.surname"
                                        v-validate="'required|min:3'">
                                    </b-form-input>
                                </b-form-group>
                                <div class="text-danger text-right" id="check_surname">
                                    <small>{{ errors.first('surname') }}</small>
                                </div>
                                <!-- Sexo !-->
                                <b-form-group
                                    :horizontal="true"
                                    class="w-100 text-right mt-3 mb-0"
                                    label="<strong>Sexo *</strong>"
                                    label-cols="4"
                                    label-for="sex">
                                    <multiselect
                                        :allowEmpty="false"
                                        :custom-label="opt => sex.find(x => x.uuid == opt).name"
                                        :multiple="false"
                                        :options="sex.map(type => type.uuid)"
                                        deselectLabel="-"
                                        name="sex"
                                        placeholder="Seleccione"
                                        selectLabel="+"
                                        v-if="sex"
                                        v-model="entity.sex">
                                    </multiselect>
                                </b-form-group>
                                <!-- Fecha de Nacimiento !-->
                                <b-form-group
                                    :horizontal="true"
                                    class="w-100 text-right mt-3 mb-0"
                                    label="<strong>F. de Nacimiento</strong>"
                                    label-cols="4"
                                    label-for="partnerBirthdate">
                                    <v-date-picker v-model="entityBirthdayFormatted" :max-date="new Date()" popoverDirection="top">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <b-form-input
                                                :value="inputValue"
                                                @change="changeBirthday"
                                                v-on="inputEvents"
                                                id="partnerBirthdate"
                                                name="partnerBirthdate"
                                                class="w-100"
                                                v-validate="'partnerBirthdate'"
                                                :state="validateState('partnerBirthdate')"
                                                aria-describedby="check_partnerBirthdate" />
                                        </template>
                                    </v-date-picker>
                                </b-form-group>
                                <div class="text-danger text-right" id="check_partnerBirthdate">
                                    <small>{{ errors.first('partnerBirthdate') }}</small>
                                </div>
                                <!-- Registro de Autónomo !-->
                                <b-form-group
                                    :horizontal="true"
                                    class="w-100 text-right mt-3 mb-0"
                                    label="<strong>Alta Autónomo</strong>"
                                    label-cols="4"
                                    label-for="autonomousRegisteredAt">
                                    <v-date-picker v-model='entityAutonomousRegisteredAtFormatted' :max-date="new Date()" popoverDirection="top">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <b-form-input
                                                :value="inputValue"
                                                @change="changeAutonomousRegistered"
                                                v-on="inputEvents"
                                                id="autonomousRegisteredAt"
                                                name="autonomousRegisteredAt"
                                                class="w-100"
                                                v-validate="{required: false, autonomousRegisteredAt: {birthday: entity.birthday}}"
                                                :state="validateState('autonomousRegisteredAt')"
                                                aria-describedby="check_autonomousRegisteredAt" />
                                        </template>
                                    </v-date-picker>
                                </b-form-group>
                                <div class="text-danger text-right" id="check_autonomousRegisteredAt">
                                    <small>{{ errors.first('autonomousRegisteredAt') }}</small>
                                </div>
                                <!-- Sede !-->
                                <b-form-group
                                    :horizontal="true"
                                    class="w-100 text-right mt-3 mb-0"
                                    label="<strong>Sede *</strong>"
                                    label-cols="4"
                                    label-for="headquartersId">
                                    <multiselect
                                        :allowEmpty="false"
                                        :custom-label="opt => headquarters.find(x => x.uuid == opt).name"
                                        :multiple="false"
                                        :options="headquarters.map(type => type.uuid)"
                                        deselectLabel="-"
                                        name="headquartersId"
                                        placeholder="Seleccione"
                                        selectLabel="+"
                                        v-if="headquarters"
                                        v-model="entity.headquartersId">
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="pt-3">
                            <div class="col float-left">
                                <button
                                    :disabled="!validate()"
                                    class="btn btn-brand btn-primary btn-lg pull-right"
                                    type="submit">
                                    Siguiente
                                </button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-card>
        </b-row>
        <hr>
    </div>
</template>

<script>
    import {request, parseRequest} from '@/helpers/services';
    import Multiselect from 'vue-multiselect';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import form from '@/helpers/form';
    import moment from 'moment';

    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: 'addPartners',
        components: {
            'v-date-picker': DatePicker,
            Multiselect
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Inicio', path: '/admin/dashboard', brand: 'fa fa-home'},
                ],
                title: 'Nuevo Socio',
                subtitle: 'Paso 1 de 4',
                // entity
                entity_url: '/members/steps/1',
                entity: {
                    nif: "",
                    name: "",
                    surname: "",
                    birthday: null,
                    autonomousRegisteredAt: null,
                    sex: 1,
                    headquartersId: "",
                    memberId: null,
                },
                // dependencies
                headquarters: [],
                sex: [
                    {uuid: 1, name: 'Hombre'},
                    {uuid: 2, name: 'Mujer'},
                    {uuid: 3, name: 'Otra identidad'},
                ],
                today: null,
                checking: false,
                // requirements
                strings: ['nif', 'name', 'surname'],
                arrays: ['headquartersId'],
                dates: ['birthday', 'autonomousRegisteredAt']
            }
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.requests('headquarters', 'get', 200, 'headquarters');
            this.today = new Date();
        },
        computed: {
            entityBirthdayFormatted: {
                get() {
                    if(!this.entity.birthday) return null;
                    return new Date(this.entity.birthday);
                },
                set(newValue) {
                    if(!newValue || newValue === "") {
                        this.entity.birthday = null;
                        return;
                    }
                    this.entity.birthday = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            },
            entityAutonomousRegisteredAtFormatted: {
                get() {
                    if(!this.entity.autonomousRegisteredAt) return null;
                    return new Date(this.entity.autonomousRegisteredAt);
                },
                set(newValue) {
                    if(!newValue || newValue === "") {
                        this.entity.autonomousRegisteredAt = null;
                        return;
                    }
                    this.entity.autonomousRegisteredAt = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            }
        },
        methods: {
            changeBirthday(value) {
                this.entityBirthdayFormatted = value;
            },
            changeAutonomousRegistered(value) {
                this.entityAutonomousRegisteredAtFormatted = value;
            },
            store() {
                let self = this;
                try {
                    self.$_loadingMixin_showLoading();
                    request(this.entity_url, 'post', 200, this.entity).then(x => {
                        x.memberId = x.uuid;
                        self.setPartner(x);
                        self.$_loadingMixin_hideLoading();
                    })
                    //this.setPartner()
                } catch (error) {
                    self.$_loadingMixin_hideLoading();
                }
            },
            async requests(path, method, okCode, entity) {
                this.$_loadingMixin_showLoading();
                this[entity] = await request(path, method, okCode);
                this.$_loadingMixin_hideLoading();
            },
            validate() {
                if (this.strings.filter(string => !this.entity[string]).length > 0) {
                    return false;
                // } else if (this.dates.filter(value => this.entity[value] == null).length > 0) {
                //     return false;
                } else if (this.arrays.filter(array => this.entity[array].length == 0).length > 0) {
                    return false;
                } else if (this.errors.items.length > 0) {
                    return false;
                } else {
                    return true;
                }
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref);
                } else {
                    return null;
                }
            },
            setPartner(entity) {
                this.$emit('sendPartner', entity)
            }
        },
        watch: {
            'entity.nif'() {
                let self = this;
                self.entity.memberId = null;
                if (form.validateNIF(self.entity.nif) || form.validateCIF(self.entity.nif)) {
                    self.$_loadingMixin_showLoading();
                    parseRequest('/members/nif/' + self.entity.nif, 'get', 200, 'entity').then(x => {
                        //self.entity = x;
                        // self.entity.memberId = x.uuid;
                        self.$_loadingMixin_hideLoading();

                        if (x.createdAt && x.updatedAt && !x.deactivatedAt) {
                            window.swal({
                                title: 'Socio Registrado',
                                html: 'Este Socio ya se encuentra dado de alta en el sistema. Se redireccionará a su ficha.',
                                type: 'warning'
                            });
                            this.$router.push('/partners/accounts/edit/' + x.uuid);
                        } else {
                            window.swal({
                                title: 'Socio existente',
                                html: 'Este Socio se encuentra registrado, pero su estado actual está de baja.<br>Puede registarlo de nuevo creando un nuevo socio.',
                                type: 'success',
                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-brand btn-primary btn-lg'
                            });
                        }

                    }).catch(error => {
                        parseRequest('/unlinked-members/nif/' + self.entity.nif, 'get', 200, 'entity').then(x => {
                            if (x.memberId) {
                                window.swal({
                                    title: 'Persona Registrada',
                                    html: 'Esta persona ya se encuentra dada de alta en el sistema como un socio vinculado. Se redireccionará a su ficha.',
                                    type: 'warning'
                                });
                                this.$router.push('/partners/accounts/edit/' + x.memberId);
                            }

                        }).catch(error => {
                            parseRequest('/clients/nif/' + self.entity.nif, 'get', 200, 'entity').then(x => {
                                window.swal({
                                    title: 'Persona Registrada',
                                    html: 'Esta persona ya se encuentra dada de alta en el sistema como no socio. Se redireccionará a lista de no socios.',
                                    type: 'warning'
                                });
                                this.$router.push('/partners/no-accounts/list');

                            }).catch(error => {
                                self.$_loadingMixin_hideLoading();
                                if (error.response.status === 404) {
                                }
                            });
                        });
                    });
                }
            }
        }
    }
</script>
